import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "272",
  "slug": "spot-india-from-satellite-imagery",
  "title": "How to Recognise India in Satellite Images",
  "excerpt": "The Himalayas border the north, with the broad Indo-Gangetic Plain below them.",
  "date": "2026-04-27",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/india.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Himalayas border the north, with the broad Indo-Gangetic Plain below them. The peninsula extends south between the Arabian Sea and Bay of Bengal. The Western Ghats run near the west coast, while the Thar Desert occupies part of the northwest."
    },
    {
      "type": "heading",
      "text": "The northern plain and the peninsula"
    },
    {
      "type": "paragraph",
      "text": "Compare the narrow western coastal belt with the wider lowlands around major east-coast deltas. Trace the hills behind each coast."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "The northern plains continue into Pakistan and Bangladesh, and rice cultivation occurs throughout South and Southeast Asia. Use a river basin or coastline to place a crop of fields; field density alone is not enough."
    }
  ],
  "imageAlt": "India regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
